<div class="header">
  <span class="header-icon-wrapper">
    <ng-content select="[icon]" class="header-icon"> </ng-content>
    @if(!hasIcon) {
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      class="header-icon"
      fill="#e8eaed"
      stroke="currentColor"
    >
      <path
        d="M320-280q17 0 28.5-11.5T360-320q0-17-11.5-28.5T320-360q-17 0-28.5 11.5T280-320q0 17 11.5 28.5T320-280Zm0-160q17 0 28.5-11.5T360-480q0-17-11.5-28.5T320-520q-17 0-28.5 11.5T280-480q0 17 11.5 28.5T320-440Zm0-160q17 0 28.5-11.5T360-640q0-17-11.5-28.5T320-680q-17 0-28.5 11.5T280-640q0 17 11.5 28.5T320-600Zm120 320h240v-80H440v80Zm0-160h240v-80H440v80Zm0-160h240v-80H440v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"
      />
    </svg>
    }
  </span>
  <div class="header-titles">
    <h3 class="header-titles-title">{{ title }}</h3>
    <p class="header-titles-subtitle">{{ subtitle }}</p>
  </div>
</div>

<ng-content select="[buttons]"> </ng-content>
@if(! hasButtons && showButton){
<button
  mat-flat-button
  [color]="buttonColor"
  type="button"
  (click)="handleClick($event)"
>
  {{ buttonTitle }}
</button>
}
